export type TasksViewMode = 'list' | 'board';

export function parseTasksViewFromUrl(urlLike: string | null | undefined): TasksViewMode | null {
  if (!urlLike) return null;
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const url = new URL(urlLike, base);
    const tasksView = url.searchParams.get('tasks_view');
    if (tasksView === 'board' || tasksView === 'list') return tasksView;
    return null;
  } catch {
    return null;
  }
}

export function buildTasksViewUrl(currentHref: string, mode: TasksViewMode): string {
  const url = new URL(currentHref);
  if (mode === 'board') {
    url.searchParams.set('tasks_view', 'board');
  } else {
    url.searchParams.delete('tasks_view');
  }
  return `${url.pathname}${url.search}${url.hash}`;
}
